import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { HttpService } from '@app/core/http/http.service';
import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';

import { DataByCountryView } from '@app/shared/models/ipm/view/DataByCountryView';

import { Observable } from 'rxjs';
import { EtlExtractionView } from '@app/shared/models/ipm/view/EtlExtractionView';

@Injectable()
export class EtlExtractionService {
  private sApiEtlExtraction = '/api/etlExtraction';
  private sApiEtlExtractionRelaunch = '/relaunch/';

  constructor(
    private httpService: HttpService,
    private translateService: TranslateService
  ) { }

  public executeExtraction(configuration: EtlExtractionView): Observable<any> {
    return this.httpService.post<any>(this.sApiEtlExtraction, configuration);
  }

  public findAllDataByCountry(): Observable<Array<DataByCountryView>> {
    return this.httpService.get<Array<DataByCountryView>>(this.sApiEtlExtraction)
      .pipe(
        map(etlExtractions => {
          return etlExtractions.map((etlExtraction: DataByCountryView) => {
            // Creados para poder filtrar en la tabla.
            etlExtraction.airlines = etlExtraction.airlines != null ? etlExtraction.airlines.replace(/'/g, "") : this.translateService.instant('ETL Executions.All Airlines');
            etlExtraction.dataKey  = etlExtraction.shortName + "-" + etlExtraction.launchTime + "-" + etlExtraction.execReport;
            etlExtraction.from     = etlExtraction.periodFrom ? etlExtraction.periodFrom?.toString() : formatDate(etlExtraction.dateFrom, 'yyyy-MM-dd', 'en-US');
            etlExtraction.to       = this.getETLExtractionTo(etlExtraction);
            return etlExtraction;
          })
        })
      );
  }

  public relaunchEtlExtraction(etlExecution : number) {
    return this.httpService.post<string>(this.sApiEtlExtraction + this.sApiEtlExtractionRelaunch + etlExecution, { });
  }

  public relaunchEtlExtractionAll(dataByCountryList: any) : Observable<string> {
    return this.httpService.post<string>(`${this.sApiEtlExtraction}/relaunch`, dataByCountryList, { responseType: 'text' as 'json' });
  }

  public deleteEtlExtraction(etlExecution : number) : Observable<string> {
    return this.httpService.delete<string>(this.sApiEtlExtraction + '/' + etlExecution);
  }

  private getETLExtractionTo(etlExtraction: DataByCountryView) {
    if (etlExtraction.periodTo) {
      return etlExtraction.periodTo?.toString();
    }

    return etlExtraction.dateTo ? formatDate(etlExtraction.dateTo, 'yyyy-MM-dd', 'en-US') : null;
  }

  public deleteEtlExtractionAll(dataByCountryList: any) {
    return this.httpService.delete<string>(`${this.sApiEtlExtraction}`, dataByCountryList);
  }

}
